const RETRY_DELAYS_MS = [250, 1000];

// Navigation is public. Do not couple its lifetime or request body to a user,
// basket ownership epoch, or authentication result.
export const startPublicHeaderLoad = (request, publish) => {
  let mounted = true;
  let retries = 0;
  let timer = null;

  const load = () => {
    Promise.resolve().then(() => mounted ? request('') : undefined).then(response => {
      if (!mounted) return;
      const data = response?.data;
      const menu = typeof data?.header === 'string' ? JSON.parse(data.header) : data?.header;
      if (!Array.isArray(menu)) throw new TypeError('Invalid public navigation');
      publish({menu, data});
    }).catch(() => {
      if (!mounted || retries >= RETRY_DELAYS_MS.length) return;
      timer = setTimeout(() => {
        timer = null;
        load();
      }, RETRY_DELAYS_MS[retries++]);
    });
  };

  load();
  return () => {
    mounted = false;
    if (timer !== null) clearTimeout(timer);
  };
};
